import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import Users from "../../assets/icons/users.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { FetchTodayOnboardDetails } from "../../redux/actions/action";

const OnBoardCard = () => {
  const dispatch = useDispatch();
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || key;
  const onboardDetails = useSelector((state) => state.user.onboardDetails);
  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
    dispatch(FetchTodayOnboardDetails());
  }, []);

  return (
    <>
      <div className="onboardCard onboardCard_Res">
        <div className="onboardTitle">
          <div>
            <span>
              {/* Onboard */}
              {t("Onboard")}
            </span>
            <span> | </span>
            <span>
              {/* Today */}
              {t("Today")}
            </span>
          </div>
          <div className="people">
            <img src={Users} />
            <text>0</text>
          </div>
        </div>
        <div className="onboardDetails">
          <div className="onboard">
            <text>
              {/* CHECKIN */}
              {t("CHECKIN")}
            </text>
            <div className="colorline" style={{ color: "#B0DD69" }}></div>
            <div>{onboardDetails?.checkin || 0}</div>
          </div>
          <div className="onboard">
            <text>
              {/* OFFLINE */}
              {t("OFFLINE")}
            </text>
            <div className="colorline" style={{ color: "#EFCB51" }}></div>
            <div>{onboardDetails?.offline || 0}</div>
          </div>
          <div className="onboard">
            <text>
              {/* SICK LEAVE */}
              {t("SICK LEAVE")}
            </text>
            <div className="colorline" style={{ color: "#F76767" }}></div>
            <div>{onboardDetails?.sickleave || 0}</div>
          </div>
          <div className="onboard">
            <text>
              {/* VACATION */}
              {t("VACATION")}
            </text>
            <div className="colorline" style={{ color: "#95A7C6" }}></div>
            <div>{onboardDetails?.vacation || 0}</div>
          </div>
          <div className="onboard">
            <text>
              {/* FREELANCING */}
              {t("FREELANCING")}
            </text>
            <div className="colorline" style={{ color: "#00246A" }}></div>
            <div>{onboardDetails?.freelancing || 0}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnBoardCard;
